// Todo: update term once PS fix term = -1 issue
const getCashOffer = (paymentDetails, creditType) => paymentDetails?.rates?.[creditType]?.cashOffers?.[-1]?.[0] ?? {};
export { getCashOffer as default };
